import { API_RENEW_SIGNATURE } from '../helpers/http/constansts';
import request from '../helpers/utils/request';
import { message as messageComponent } from '../components/forgotPassword';

class RenewSignature {

  constructor(DigitalSignature) {
    this.digitalSignature = DigitalSignature;
  }

  init() {
    const { renderMessage, digitalSignature } = this;
    const loader = document.querySelector('#signature-digital__loader');

    document.querySelector('#signature-digital__forgot-password').addEventListener('click', () => {
      digitalSignature._keyboard.clearKeyboard();
      loader.classList.add('signature-digital__loader--show');

      request(API_RENEW_SIGNATURE, { method: 'PATCH' }, (response) => {
        
        const isSuccessMessage = (response && response.data);
        const message = isSuccessMessage ?
          `${process.env.MESSAGE_RENEW_SUCCESS}` :
          `${process.env.MESSAGE_RENEW_ERROR}`;

        renderMessage(message, isSuccessMessage);
        loader.classList.remove('signature-digital__loader--show');
        digitalSignature.update();
      });
    });
  }

  renderMessage(message, typeMessage) {
    const hasError = typeMessage ? 'success' : 'error';
    const messageBox = document.querySelector('#signature-digital__forgot-password-message');
    
    messageBox.innerHTML = messageComponent(message, hasError);

    setTimeout(() => {
      messageBox.innerHTML = '';
    }, 6000);
  }
}

export default RenewSignature;